import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/auth/Login'
import SignUp from '@/components/auth/SignUp'
import VerifyEmail from '@/components/auth/VerifyEmail'
import ConfirmationEmailSent from '@/components/auth/ConfirmationEmailSent'
import ResetPassword from '@/components/auth/ResetPassword'
import ConfirmResetPassword from '@/components/auth/ConfirmResetPassword'
import OperatorsList from '@/components/operators/OperatorList'
import Dashboard from '@/components/dashboard/Dashboard'
import Violations from '@/components/dashboard/Violations'
import Revisions from '@/components/dashboard/Revisions'
import OperatorAdd from '@/components/operators/OperatorAdd'
import OperatorEdit from '@/components/operators/OperatorEdit'
import OperatorReports from '@/components/operators/OperatorReports'
import GuestVisits from '@/components/guests/App'
import GuestVisitAdd from '@/components/guests/GuestVisitAdd'
import GuestVisitEdit from '@/components/guests/GuestVisitEdit'
import ImportFromFile from '@/components/guests/ImportFromFile'
import ImportXmlHelp from '@/components/manuals/ImportXmlHelp'
import ActivateAccount from '@/components/manuals/ActivateAccount'
import Stats from '@/components/dashboard/Stats'
import TicketList from '@/components/support/TicketList'
import TicketAdd from '@/components/support/TicketAdd'
import TicketComments from '@/components/support/TicketComments'
import LiveStats from '@/components/dashboard/LiveStats'
import UserProfile from '@/components/user/Profile'
import {USER_ROLE_UNREGISTERED, USER_ROLE_GUEST, USER_ROLE_REGISTERED, USER_ROLE_ADMIN} from "../constants"

Vue.use(Router)

export default new Router({
  routes: [
    // Логин, регистрация, пароли
    {
      path: '/user/login',
      component: Login,
      name: 'login',
      meta: {auth: false, bodyClass: 'be-splash-screen'}
    },
    {
      path: '/user/signup',
      component: SignUp,
      name: 'signup',
      meta: {auth: false, bodyClass: 'be-splash-screen'}
    },
    {
      path: '/user/signup/success',
      component: ConfirmationEmailSent,
      name: 'signupSuccess',
      meta: {auth: false, bodyClass: 'be-splash-screen'}
    },
    {
      path: '/user/signup/verifyEmail',
      component: VerifyEmail,
      meta: {auth: false}
    },
    {
      path: '/user/resetPassword',
      component: ResetPassword,
      name: 'resetPassword',
      meta: {auth: false, bodyClass: 'be-splash-screen'}
    },
    {
      path: '/user/confirmResetPassword/:uid/:token/',
      component:ConfirmResetPassword,
      name: 'confirmResetPassword',
      meta: {auth: false, bodyClass: 'be-splash-screen'},
      props: true
    },
    {
      path: '/user/:id/profile/',
      component: UserProfile,
      name: 'userProfile',
      props: true,
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_ADMIN,
            access: true,
          },
          {
            role: USER_ROLE_GUEST,
            access: true,
          },
          {
            role: USER_ROLE_REGISTERED,
            access: true,
          }
        ]
      }
    },

    // Дашборд и внесение данных
    {
      path: '/dashboard',
      component: Dashboard,
      name: 'dashboard',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      }
    },
    {
      path: '/operators/:operatorId/visits',
      component: GuestVisits,
      name: 'operator-visits',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      },
      props: true
    },
    {
      path: '/operators/:operatorId/reports/:reportId',
      component: OperatorReports,
      name: 'operator-reports',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_ADMIN,
            access: true,
          },
           {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          },
           {
            role: USER_ROLE_REGISTERED,
            access: false,
            redirect: "dashboard"
          }
        ]
      },
      props: true
    },
    {
      path: '/operators/:operatorId/importFromFile',
      component: ImportFromFile,
      name: 'operator-import-file',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      },
      props: true
    },
    {
      path: '/operators/:operatorId/visits/add',
      component: GuestVisitAdd,
      name: 'guest-visit-add',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      },
      props: true
    },
    {
      path: '/operators/:operatorId/visits/:visitId/edit',
      component: GuestVisitEdit,
      name: 'guest-visit-edit',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      },
      props: true
    },

    // Управление операторами
    {
      path: '/operators-manage/',
      component: OperatorsList,
      name: 'operators',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      }
    },
    {
      path: '/operators-manage/add',
      component: OperatorAdd,
      name: 'operator-add',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      }
    },
    {
      path: '/operators-manage/:id/edit',
      component: OperatorEdit,
      props: true,
      name: 'operator-edit',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      }
    },
    // Страницы инструкций
    {
      path: '/manuals/importFromFile',
      component: ImportXmlHelp,
      name: 'importfile-manual',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      }
    },
    {
      path: '/manuals/activateAccount',
      component: ActivateAccount,
      name: 'activate-account-manual',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: true
          }
        ]
      }
    },

    {
      path: '*',
      redirect: {name: 'operators'}
    },

    // Статистика
    {
      path: '/stats/',
      component: Stats,
      name: 'stats',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_ADMIN,
            access: true,
          },
           {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          },
           {
            role: USER_ROLE_REGISTERED,
            access: false,
            redirect: "dashboard"
          }
        ]
      }
    },
    {
      path: '/live',
      component: LiveStats,
      name: 'liveStats',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_ADMIN,
            access: true,
          },
           {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          },
           {
            role: USER_ROLE_REGISTERED,
            access: false,
            redirect: "dashboard"
          }
        ]
      }
    },
     {
      path: '/violations',
      component: Violations,
      name: 'violations',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_ADMIN,
            access: true,
          },
           {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          },
           {
            role: USER_ROLE_REGISTERED,
            access: false,
            redirect: "dashboard"
          }
        ]
      }
    },
    {
      path: '/revisions',
      component: Revisions,
      name: 'revisions',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_ADMIN,
            access: true,
          },
           {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          },
           {
            role: USER_ROLE_REGISTERED,
            access: false,
            redirect: "dashboard"
          }
        ]
      }
    },
    // Служба поддержки
    {
      path: '/support/tickets',
      component: TicketList,
      name: 'support',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      }
    },
    {
      path: '/support/tickets/add/',
      component: TicketAdd,
      name: 'ticket-add',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      }
    },
    {
      path: '/support/tickets/:ticketId/comments',
      component: TicketComments,
      name: 'ticket-comments',
      meta: {
        auth: true,
        permissions: [
          {
            role: USER_ROLE_GUEST,
            access: false,
            redirect: "activate-account-manual"
          }
        ]
      },
      props: true
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js